import { render, staticRenderFns } from "./ControllerTime.vue?vue&type=template&id=5b5548cf&scoped=true&"
import script from "./ControllerTime.vue?vue&type=script&lang=js&"
export * from "./ControllerTime.vue?vue&type=script&lang=js&"
import style0 from "./ControllerTime.vue?vue&type=style&index=0&id=5b5548cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5548cf",
  null
  
)

export default component.exports